import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MemberService } from '../../services/jrni/member.service';
import { AlertService } from '../../_alert';
import { AppConfig } from '../../app.config';
import { ApiService } from '../../services/jrni/api.service';
import { DepartmentService } from '../../services/jrni/department.service';


@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  member;
  customerQuestions;
  answers;
  registrationOption = false;
  submitted: boolean;
  bookingQuestionsConfig = AppConfig.settings.bookingQuestions;
  extraForms: any = {}
  canSubmit: any = false;
  addresses: any = []
  addressesShow: any = []
  vehicles: any = []
  vehiclesShow: any = []
  maxChildren: number = 3
  showForms = false
  formStatus: any = {};
  constructor(
    private memberService: MemberService,
    private departmentService: DepartmentService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private translateService: TranslateService
  ) { }

  // Initialise the form
  memberDetailsForm: FormGroup = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    mobile: new FormControl('', [Validators.minLength(5)]),
    address1: new FormControl(''),
    address2: new FormControl(''),
    address4: new FormControl(''),
    country: new FormControl(''),
    postcode: new FormControl(''),
    email: new FormControl('', Validators.required)
  });

  get form() { return this.memberDetailsForm.controls; }

  async ngOnInit() {
    this.memberService.getMember().then(member => {
      this.spinner.show()
      this.member = member;
      // Set the customer answers
      this.answers = this.member.q;
      // Once the member has loaded then set the email and disable the control
      this.form.email.setValue(this.member.email);
      this.form.email.disable();
      // Set member attributes
      this.setMemberDetails();

      this.loadQuestions(member);
    });
  }

  // Requests the customer questions from the department
  loadQuestions(member) {
    this.departmentService.getParentDepartment().then(async parentCompany => {
      this.departmentService.set(parentCompany);
      for (let i = 1; i <= this.maxChildren; i++) {

        const address: any = await this.apiService.getHwrcAddressForm(member.id, parentCompany.id, i)
        if (address.hasOwnProperty('Item')) {
          this.addressesShow.push({ edit: false, destroy: false })
          this.addresses.push(address.Item)
        }
        const vehicle: any = await this.apiService.getHwrcVehicleForm(member.id, parentCompany.id, i)
        if (vehicle.hasOwnProperty('Item')) {
          this.vehiclesShow.push({ edit: false, destroy: false })
          this.vehicles.push(vehicle.Item)
        }
      }
      this.showForms = true
      console.log(this.addresses, this.vehicles)
      console.log(this.addressesShow, this.vehiclesShow)

      // Get the customer questions
      this.departmentService.getCustomerQuestions().then(questions => {
        this.customerQuestions = questions;

        for (let index = 0; index < this.customerQuestions.length; index++) {
          const question = this.customerQuestions[index];
          question.visible = false;
          question.reference = question.id;
          if (!question.admin_only) {
            if (!question.settings.hasOwnProperty('conditional_question')) {
              question.visible = true;
            }

            const questionControl = question.id;
            if (question.default == 1 && question.detail_type == 'check' || question.default == 1 && question.detail_type == 'check-price') {
              if (question.required) {
                this.memberDetailsForm.addControl(questionControl, new FormControl(true, Validators.required));
              } else {
                this.memberDetailsForm.addControl(questionControl, new FormControl(true));
              }
            } else {
              if (question.required) {
                this.memberDetailsForm.addControl(questionControl, new FormControl('', Validators.required));
              } else {
                this.memberDetailsForm.addControl(questionControl, new FormControl(''));
              }
            }
          }
        }
        this.populateQuestions();
        this.spinner.hide()
      }, err => {
        this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
        this.spinner.hide();
      });
    });
  }

  // Once the form has loaded and the questions have been rerieved then populate
  // the form with the users customer questions
  populateQuestions() {
    for (const key in this.answers) {
      const ans = this.answers[key];
      if (this.form[key]) {
        this.form[key].setValue(ans.answer);
      }
    }
    this.onQuestionChange();
  }

  // Handles conditional questions and updates the view accordingly
  onQuestionChange() {
    const customerQuestions = this.customerQuestions
    // Conditional questions logic
    for (let index = 0; index < customerQuestions.length; index++) {
      const q = customerQuestions[index];
      // If the question has settings and relies on a conditional question
      if (q.settings && q.settings.hasOwnProperty('conditional_question')) {
        // Get the conditional question based on the id set in q
        const conditionalQ = customerQuestions.filter(question => question.id == q.settings.conditional_question);
        // Get the question control
        const questionControl = this.form[q.settings.conditional_question];
        // If the question control has a value get the option from the contional question. This will allow
        // us to check if q is shown when value is selected
        const option = conditionalQ[0].options.filter(option => option.name == questionControl.value);

        // If the conditional question is visible and the value chosen === to qs conditional answer then show q
        if (conditionalQ.length > 0 && conditionalQ[0].visible && option.length > 0 && q.settings.conditional_answers.hasOwnProperty(option[0].id)) {
          this.form[q.id].enable();
          // If the condiditonal question is important, Hide it
          if (q.important) {
            q.visible = false;
          } else {
            q.visible = true;
          }
        } else {
          q.visible = false;
          this.form[q.id].setValue('');
          this.form[q.id].disable();
        }
      }
    }
  }

  // Cancel any changes made to the form data
  cancel() {
    this.setMemberDetails();
    this.populateQuestions();
  }

  // Set the values in the form using the members details from member object
  setMemberDetails() {
    // Set member attributes
    let fullMobile = `${this.member.mobile}`
    if (fullMobile) {
      if (fullMobile[0] !== "0") {
        fullMobile = "0" + fullMobile
      }
    }
    this.form.first_name.setValue(this.member.first_name);
    this.form.last_name.setValue(this.member.last_name);
    this.form.mobile.setValue(fullMobile);
    this.form.address1.setValue(this.member.address1);
    this.form.address2.setValue(this.member.address2);
    this.form.address4.setValue(this.member.address4);
    this.form.country.setValue(this.member.country);
    this.form.postcode.setValue(this.member.postcode);
  }

  // Submit the form update
  async onSubmit() {

    this.alertService.clear();
    this.submitted = true;
    // Create the questions object for the member update request
    this.memberDetailsForm.value['q'] = {};

    // if (!this.extraForms["address_registration_form"] || !this.extraForms["vehicle_registration_form"]) {
    //   console.log("sub forms", this.extraForms["address_registration_form"], this.extraForms["vehicle_registration_form"])
    //   this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
    //   this.scrollToTop();
    //   return;
    // }

    for (let index = 0; index < this.customerQuestions.length; index++) {
      const question = this.customerQuestions[index];
      if (question.id === this.bookingQuestionsConfig.schoolNameSelectionAccounts) {
        const test = question.options.filter(option => option.name == this.memberDetailsForm.value[this.bookingQuestionsConfig.schoolNameSelectionAccounts]);
        test.length > 0 ? this.memberDetailsForm.controls[this.bookingQuestionsConfig.schoolNameSelectionAccounts].setErrors(null) : this.memberDetailsForm.controls[this.bookingQuestionsConfig.schoolNameSelectionAccounts].setErrors({ 'selectedSchoolErr': "Please select a school from the list" });
      }
    }

    if (this.memberDetailsForm.invalid) {
      console.log("form")
      this.alertService.warn(this.translateService.instant('FORM.VALIDATION_ERR_MSG'));
      // scroll to the top of the page if form is invalid
      this.scrollToTop();
      return;
    } else {
      this.spinner.show();

      // Create the q {} containing the updated answers
      for (const key in this.customerQuestions) {
        const question = this.customerQuestions[key];
        const questionObj = {
          answer: this.memberDetailsForm.value[question.id],
          name: question.name
        };
        this.memberDetailsForm.value['q'][question.id] = questionObj;
      }



      // Update the member call
      this.memberService.updateMember(this.member, this.memberDetailsForm.value).then(async member => {
        // let form_no: number = 1;
        // for (let address of this.extraForms["address_registration_form"]) {
        //   const addressBody = {
        //     'address_no': form_no,
        //     'postcode': address.value['postcode'],
        //     'address': address.value['address'],
        //   }
        //   await this.apiService.saveHwrcAddressForm(member.id, parentCompany.id, addressBody)
        //   form_no++
        // }

        // form_no = 1
        // for (let vehicle of this.extraForms["vehicle_registration_form"]) {
        //   const addressBody = {
        //     'vehicle_no': form_no,
        //     'vehicle_registration': vehicle.value['vehicle_registration'],
        //     'vehicle_make': vehicle.value['vehicle_make'],
        //     'vehicle_colour': vehicle.value['vehicle_colour'],
        //     'is_this_a_restricted_vehicle': vehicle.value['is_this_a_restricted_vehicle'],
        //   }
        //   await this.apiService.saveHwrcVehicleForm(member.id, parentCompany.id, addressBody)
        //   form_no++
        // }
        this.memberService.setMember(member);
        this.member = member;
        // Set the customer answers
        this.answers = this.member.q;
        this.alertService.success(this.translateService.instant('ACCOUNT.UPDATE_SUCCESS'));
        // scroll to the top of the page if form update is successful
        this.scrollToTop();
        this.spinner.hide();
        return;
      }).catch((error: HttpErrorResponse) => {
        this.alertService.error(this.translateService.instant('ACCOUNT.UPDATE_FAILED'))
        // scroll to the top of the page if form update is unsuccessful
        this.scrollToTop();
        this.spinner.hide();
      });
    }
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }

  // Number input text validation, keycode 8 is backspace
  keyPressNumberField(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  async test(formStatus: any, idx: any) {
    console.log(`form status:`, formStatus);
    console.log(`form status:`, formStatus.errors);
    console.log(`form status:`, formStatus.errors.length);
    console.log(`form status:`, formStatus.idx);
    console.log(`form status:`, formStatus.formId + formStatus.idx);

    this.formStatus[formStatus.formId + formStatus.idx] = formStatus.errors.length > 0  
    console.log("this.formStatus[formStatus.formId + idx] ", this.formStatus[formStatus.formId + formStatus.idx])
    if (formStatus.status) {
      this.extraForms[formStatus.formId + formStatus.idx] = formStatus.data
    } else {
      this.extraForms[formStatus.formId + formStatus.idx] = formStatus.status
    }
    console.log(this.extraForms)
    // if (this.extraForms['address_registration_form'] && this.extraForms['vehicle_registration_form']) {
    //   this.canSubmit = true
    // } else {
    //   this.canSubmit = false
    // }
  }

  async add(formId) {
    if (formId === 'address_registration_form') {
      this.addresses.push({})
      this.addressesShow.push({ edit: true, destroy: false })
    }
    if (formId === 'vehicle_registration_form') {
      this.vehicles.push({})
      this.vehiclesShow.push({ edit: true, destroy: false })
    }
  }

  async destroy(formId, idx) {
    this.departmentService.getParentDepartment().then(async parentCompany => {

      this.spinner.show();
      if (formId === 'address_registration_form') {
        await this.removeEntry(formId, idx, parentCompany, this.addresses, this.addressesShow, "address_no")
      }
      if (formId === 'vehicle_registration_form') {
        await this.removeEntry(formId, idx, parentCompany, this.vehicles, this.vehiclesShow, "vehicle_no")
      }

      this.alertService.success(this.translateService.instant('ACCOUNT.DELETE_SUCCESS'));
      this.scrollToTop();
      this.spinner.hide();
    });
  }

  // removes the entry, then update the ids of the other ones so there are no numerical gaps 
  async removeEntry(formId, idx, parentCompany, dataArr, showArr, no) {
    // so if we have 1,2,3, and want to delete 2, we move 2 to the end of the array, making it 3
    dataArr.push(dataArr.splice(idx, 1)[0])
    showArr.push(showArr.splice(idx, 1)[0])

    // then we save the new states of the remaining objects and delete the value we moved to the end
    for (let i in dataArr) {
      dataArr[i][no] = parseInt(i) + 1
      await this.updateOrDestroy(formId, dataArr[i], parseInt(i) === dataArr.length - 1, parentCompany)
    }
    // finlay remove it from the local array as well
    dataArr.pop()
    showArr.pop()
  }

  async updateOrDestroy(formId, entry, destroy, parentCompany) {
    this.spinner.show();
    console.log(entry)
    if (formId === 'address_registration_form') {

      const addressBody = {
        'address_no': entry.address_no,
        'postcode': entry.postcode,
        'address': entry.address,
        'delete': destroy
      }
      await this.apiService.saveHwrcAddressForm(this.member.id, parentCompany.id, addressBody)
    }
    if (formId === 'vehicle_registration_form') {
      const vehicleBody = {
        'mode_of_transport': entry.mode_of_transport,
        'vehicle_no': entry.vehicle_no,
        'vehicle_registration': entry.vehicle_registration,
        'vehicle_make': entry.vehicle_make,
        'vehicle_colour': entry.vehicle_colour,
        'is_this_a_restricted_vehicle': entry.is_this_a_restricted_vehicle,
        'vehicle_type': entry.vehicle_type,
        'other_vehicle': entry.other_vehicle,
        'delete': destroy
      }
      await this.apiService.saveHwrcVehicleForm(this.member.id, parentCompany.id, vehicleBody)
    }
  }
  keyPnter(form) {
    return Object.keys(form).toString()
  }
  async save(formId, idx) {
    if (this.extraForms[formId + idx]) {
      this.departmentService.getParentDepartment().then(async parentCompany => {
        this.spinner.show();
        if (formId === 'address_registration_form') {
          const addressBody = {
            'address_no': idx + 1,
            'postcode': this.extraForms[formId + idx][0].value['postcode'],
            'address': this.extraForms[formId + idx][0].value['address'],
          }
          await this.apiService.saveHwrcAddressForm(this.member.id, parentCompany.id, addressBody)

          this.addressesShow[idx] = { edit: false, destroy: false }
          const address: any = await this.apiService.getHwrcAddressForm(this.member.id, parentCompany.id, idx + 1)
          if (address.hasOwnProperty('Item')) {
            this.addresses[idx] = address.Item
          }

          this.alertService.success(this.translateService.instant('ACCOUNT.UPDATE_SUCCESS'));
          // scroll to the top of the page if form update is successful
          this.scrollToTop();
          this.spinner.hide();
        }
        if (formId === 'vehicle_registration_form') {
          console.log("this.extraForms", this.extraForms)
          const vehicleBody = {
            'vehicle_no': idx + 1,
            'mode_of_transport': this.extraForms[formId + idx][0].value['mode_of_transport'],
            'vehicle_registration': this.extraForms[formId + idx][0].value['vehicle_registration'],
            'vehicle_make': this.extraForms[formId + idx][0].value['vehicle_make'],
            'vehicle_colour': this.extraForms[formId + idx][0].value['vehicle_colour'],
            'is_this_a_restricted_vehicle': this.extraForms[formId + idx][0].value['is_this_a_restricted_vehicle'],
            'vehicle_type': this.extraForms[formId + idx][0].value['vehicle_type'],
            'other_vehicle': this.extraForms[formId + idx][0].value['other_vehicle'],
          }
          console.log("vehicleBody", vehicleBody)
          await this.apiService.saveHwrcVehicleForm(this.member.id, parentCompany.id, vehicleBody)

          this.vehiclesShow[idx] = { edit: false, destroy: false }
          const vehicle: any = await this.apiService.getHwrcVehicleForm(this.member.id, parentCompany.id, idx + 1)
          console.log(vehicle)
          if (vehicle.hasOwnProperty('Item')) {
            this.vehicles[idx] = vehicle.Item
          }

          this.alertService.success(this.translateService.instant('ACCOUNT.UPDATE_SUCCESS'));
          // scroll to the top of the page if form update is successful
          this.scrollToTop();
          this.spinner.hide();
        }
      })
    }
  }

  cancelEdit(show, entries, idx, no) {
    console.log(entries[idx])
    console.log(no)
    if (no) {
      show[idx].edit = false
    } else {
      show.splice(idx, 1)
      entries.splice(idx, 1)
    }

  }
}